import type {PermissionsRecordType} from '../permissions';

export const sourcingPermissions = {
  sourcingRead: {
    actionId: 'READ',
    resourceId: 'SOURCING',
    scopes: [],
  },
  sourcingOffersRead: {
    actionId: 'READ',
    resourceId: 'AUCTION',
    scopes: [],
  },
} satisfies PermissionsRecordType;
